module.exports = __webpack_public_path__ + "static/media/error-bg.1d371844.jpg";